"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  props: {
    tableData: {
      type: Array,
      default: null
    }
  },
  data: function data() {
    return {
      homeTopData: {
        isShow: 1,
        bg: ''
      },
      baseData: {},
      boole1: false,
      boole2: false,
      boole3: false,
      boole4: false,
      boole5: false,
      boole6: false,
      boole7: false
    };
  },
  watch: {
    tableData: {
      // 首页数据
      handler: function handler(newVal, oldVal) {
        // newVal是获取的是新的值
        console.log(newVal, '新的变化');
        var result = newVal.reduce(function (acc, item) {
          var key = "localLife".concat(item.actNum ? item.actNum : item.category);
          acc[key] = item;
          return acc;
        }, {});
        this.baseData = result;
        this.$forceUpdate(); // 刷新视图
      },
      deep: true // deep属性是深度监听对象里的属性的值是否改变。
    }
  },
  methods: {
    bothClick: function bothClick(val) {
      this.$emit('childData', val);
    },
    bothMouseOver: function bothMouseOver(val) {
      if (val === 1) {
        this.boole1 = true;
      } else if (val === 2) {
        this.boole2 = true;
      } else if (val === 3) {
        this.boole3 = true;
      } else if (val === 4) {
        this.boole4 = true;
      } else if (val === 5) {
        this.boole5 = true;
      } else if (val === 6) {
        this.boole6 = true;
      } else if (val === 7) {
        this.boole7 = true;
      } else if (val === 8) {
        this.boole8 = true;
      } else if (val === 9) {
        this.boole9 = true;
      } else if (val === 10) {
        this.boole10 = true;
      } else if (val === 13) {
        this.boole13 = true;
      } else if (val === 14) {
        this.boole14 = true;
      }
    },
    bothMouseLeave: function bothMouseLeave(val) {
      if (val === 1) {
        this.boole1 = false;
      } else if (val === 2) {
        this.boole2 = false;
      } else if (val === 3) {
        this.boole3 = false;
      } else if (val === 4) {
        this.boole4 = false;
      } else if (val === 5) {
        this.boole5 = false;
      } else if (val === 6) {
        this.boole6 = false;
      } else if (val === 7) {
        this.boole7 = false;
      } else if (val === 8) {
        this.boole8 = false;
      } else if (val === 9) {
        this.boole9 = false;
      } else if (val === 10) {
        this.boole10 = false;
      } else if (val === 13) {
        this.boole13 = false;
      } else if (val === 14) {
        this.boole14 = false;
      }
    }
  }
};